import { render } from "./TableActions.vue?vue&type=template&id=2a490674"
import script from "./TableActions.vue?vue&type=script&lang=js"
export * from "./TableActions.vue?vue&type=script&lang=js"

import "./TableActions.vue?vue&type=style&index=0&id=2a490674&lang=scss"
script.render = render

export default script